import authApi from 'api/auth';
import authEffects from 'effector/session/effects';

export default (): void => {
  authEffects.login.use(authApi.login);
  authEffects.logout.use(authApi.logout);
};
